import React from 'react';

import AddressBack from './BackFlow';
import AddressFront from './FrontFlow';

const BusinessInfo = ({
  businessId,
  address,
  form,
  flow,
}) => {

  if (flow === 'back') {
    return <AddressBack businessId={businessId} form={form} />;
  }

  return <AddressFront businessId={businessId} form={form} address={address} />;
};

export default BusinessInfo;
